import { Dimmer } from "@/components/spinner";
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { Mensaje } from "@/components/mensajes2";
import useTableR from "@/components/useTableR";
import { formatMoneda } from "@/util/varios";
export default function CatalogoTipoMulta(props) {
  const op = require("@/modulos/datos");
  const token = localStorage.getItem("jwtToken");
  const [loading, setLoading] = useState(false);
  const [records, setRecords] = useState([]);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const headCells = [
    {
      id: "1",
      label: "Codigo",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "white",
    },
    {
      id: "2",
      label: "Descripcion",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "white",
    },
    {
      id: "3",
      label: "Valor",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "white",
    },
  ];
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const buscarRegistros = ({ tipo }) => {
    const tipoImpuesto =
      tipo === "comercio"
        ? "ACTIVIDADES ECONOMICAS"
        : tipo === "licores"
          ? "RENTAS DE LICORES"
          : "";
    setLoading(true);
    const campos = "*";
    const nomtab = `tipomulta 
    where tipoimpuesto = '${tipoImpuesto}'`;
    const orden = "idtipomulta desc";
    const endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.status === 200 && res.data && res.data.length > 0) {
          setRecords(res.data);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: "Error al Cargar los Tipos de Multas",
          icono: "error",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableR(records, headCells, filterFn);
  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idtipomulta.includes(target.value) ||
              x.descripcion.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };
  const salir = () => {
    props.onHide();
  };
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        buscarRegistros({ tipo: props.tipo });
      }}
    >
      <Modal.Header className="azulGradiant px-4 py-2 text-uppercase">
        <h3 className="fs-4 fw-bold text-light m-0">Tipo de Multa</h3>
        <button className="btn btn-sm bg-light" onClick={() => salir()}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="col-12 m-0 p-0 d-flex justify-content-between row">
          <div className="col-5 input-group input-group-sm m-1 p-1 mr-auto">
            <input
              type="text"
              onChange={handleSearch}
              className="form-control rounded-pill search-input"
              placeholder="Buscar..."
            />
          </div>
        </div>
        <div className="col-12 m-0 p-0">
          <TblContainer>
            <TblHead />
            {records &&
              recordsAfterPagingAndSorting().map((item, index) => (
                <tr
                  key={index}
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    props.seleccionarRegistro(item);
                  }}
                >
                  <td
                    className="align-baseline"
                    style={{ textAlign: "center", width: "10px" }}
                  >
                    {item.idtipomulta}
                  </td>
                  <td
                    className="align-baseline"
                    style={{ textAlign: "left", width: "auto" }}
                  >
                    {item.descripcion}
                  </td>
                  <td
                    className="align-baseline"
                    style={{ textAlign: "center", width: "10px" }}
                  >
                    {formatMoneda(
                      item.valor.toString().replace(".", ","),
                      ",",
                      ".",
                      2,
                    )}
                  </td>
                </tr>
              ))}
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          onClick={() => salir()}
          className="btn-sm rounded-pill btn btn-danger col-md-2"
        >
          <i className="fa fa-window-close"></i> Salir
        </button>
      </Modal.Footer>
      <Dimmer active={loading} inverted />
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
    </Modal>
  );
}
